import createActionButton from '@/components/actions/actions';
import { ActionIcon, type ActionIconProps, type PolymorphicComponentProps } from '@mantine/core';
import { type PropsWithChildren } from 'react';

interface Props extends PolymorphicComponentProps<'button', ActionIconProps> {}

export type ActionIconButtonProps = PropsWithChildren<typeof ActionIconButton>;

const ActionIconButton = createActionButton<Props>(ActionIcon);
export default ActionIconButton;
